import React, { ReactNode, RefObject } from 'react';
import { IEntity } from '../../../../../../../types/api/entities/IEntity';
import { murmurhash } from '../../../../../../../lib/js/hash';

import ListItemContainer from '../ListItemContainer/ListItemContainer';
import { Selected } from '../hooks/usePopupKeyboardNavigation';

export type ListProps<T extends IEntity> = {
  id: string;
  results: T[];
  clickHandler: (event: Selected<T>) => void;
  selectedItemId?: string;
  selectedItemRef?: RefObject<HTMLDivElement | null>;
  children: (item?: T) => ReactNode;
  headline?: string;
};

export function List<T extends IEntity>(props: ListProps<T>) {
  return (
    <div className="combobox__listitems-group">
      {/* headline only for visual reasons, no semantics needed here, <div> is ok! */}
      {props.headline && (
        <div id={`combobox-listbox-headline-${murmurhash(props.headline)}`} className="combobox__listbox-headline">
          {props.headline}
        </div>
      )}
      {props.results.length > 0 ? (
        <>
          {props.results.map(item => {
            const node = props.children(item);
            const selected = props.selectedItemId === item.id;
            return (
              node && (
                <ListItemContainer
                  id={props.id}
                  key={`forms-combobox-list-item-${item.id}`}
                  idPostFix={item.id}
                  clickHandler={event => props.clickHandler({ event, selectedItem: item })}
                  reference={selected ? props.selectedItemRef : undefined}
                  selected={selected}
                >
                  {node}
                </ListItemContainer>
              )
            );
          })}
        </> // render each given item
      ) : (
        props.children() // render placeholder for empty list
      )}
    </div>
  );
}
